"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Select = require("react-select");
const react_redux_1 = require("react-redux");
const libs_1 = require("../../../libs");
const util_1 = require("util");
const DialogReducer_1 = require("../DialogReducer");
const react_bootstrap_1 = require("react-bootstrap");
const DialogActions_1 = require("../DialogActions");
const Loader_1 = require("../../Loader");
const CheckboxIcon_1 = require("../../CheckboxIcon");
const mapStateToProps = state => {
    return state.dialogReducer;
};
class DialogComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            blackWordErrors: { badWord: null, replaceTo: null },
            checkedNumbersForUnblock: []
        };
    }
    componentWillReceiveProps(nextProps) {
        let newState = { show: nextProps.type !== DialogReducer_1.DialogType.Hidden };
        if (nextProps.type === DialogReducer_1.DialogType.Select) {
            const options = nextProps.payload;
            const select2 = options.select2 || { defaultValue: null };
            newState.inputValue = select2.defaultValue;
        }
        if (nextProps.type === DialogReducer_1.DialogType.Input) {
            const options = nextProps.payload;
            const inputType = options && options.inputType || "text";
            const isCheckbox = inputType === 'checkbox';
            newState.inputValue = isCheckbox ? false : undefined;
        }
        if (nextProps.type === DialogReducer_1.DialogType.BlackWord) {
            const options = nextProps.payload;
            this.setState({ blackWordErrors: options.blackWordErrors });
        }
        this.setState(newState);
    }
    render() {
        switch (this.props.type) {
            case DialogReducer_1.DialogType.Alert:
                return this.alertDialog();
            case DialogReducer_1.DialogType.Confirm:
                return this.confirmDialog();
            case DialogReducer_1.DialogType.Custom:
                return this.customDialog();
            case DialogReducer_1.DialogType.Input:
                return this.inputDialog();
            case DialogReducer_1.DialogType.Select:
                return this.selectDialog();
            case DialogReducer_1.DialogType.BlockedNumbers:
                return this.blockedNumbersDialog();
            case DialogReducer_1.DialogType.BlackWord:
                return this.BlackWordDialog();
            default:
                return React.createElement(Loader_1.default, { libraries: [libs_1.ReactSelect], onLoad: () => {} });
        }
    }
    close() {
        this.setState({
            show: false,
            checkedNumbersForUnblock: [],
            blackWordErrors: { badWord: null, replaceTo: null }
        });
        if (!util_1.isNullOrUndefined(this.props.payload.onClose)) {
            this.props.payload.onClose();
        }
    }
    onExited() {
        DialogActions_1.closeDialog();
    }
    customDialog() {
        const options = this.props.payload;
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => !options.negativeButtonText && this.close(), onExited: this.onExited }, options.header, options.body, options.footer, !util_1.isNullOrUndefined(options.negativeButtonText) && React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                this.close();
            } }, options.negativeButtonText)));
    }
    confirmDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Yes";
        const negativeButtonText = options.negativeButtonText || "No";
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, { dangerouslySetInnerHTML: { __html: options.message } }), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: () => {
                options.onPositive();
                autoClose && this.close();
            } }, positiveButtonText), !util_1.isNullOrUndefined(options.thirdButtonText) && React.createElement(react_bootstrap_1.Button, { bsStyle: "warning", onClick: () => {
                options.onThirdButton();
                autoClose && this.close();
            } }, options.thirdButtonText), React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                if (!util_1.isNullOrUndefined(options.onNegative)) {
                    options.onNegative();
                }
                autoClose && this.close();
            } }, negativeButtonText)));
    }
    inputDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Ok";
        const negativeButtonText = options.negativeButtonText || "Cancel";
        const inputType = options.inputType || "text";
        const messageStyle = options.messageStyle || "";
        const isCheckbox = inputType === 'checkbox';
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement(react_bootstrap_1.FormGroup, { controlId: "confirmDialogInput" }, isCheckbox ? React.createElement("div", null, React.createElement(CheckboxIcon_1.default, { checked: this.state.inputValue, onClick: event => {
                this.setState(prevState => {
                    return {
                        inputValue: !prevState.inputValue
                    };
                });
                this.forceUpdate();
            } }), React.createElement(react_bootstrap_1.ControlLabel, { className: messageStyle, dangerouslySetInnerHTML: { __html: options.message } })) : React.createElement("div", null, React.createElement(react_bootstrap_1.ControlLabel, { className: messageStyle, dangerouslySetInnerHTML: { __html: options.message } }), React.createElement(react_bootstrap_1.FormControl, { type: inputType, placeholder: options.inputPlaceholder, onChange: event => this.setState({ inputValue: event.target.value }) }), React.createElement("small", { className: "text-warning" }, options.smallText || ""), React.createElement(react_bootstrap_1.FormControl.Feedback, null)))), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { type: "button", bsStyle: "primary", onClick: () => {
                options.onPositive(this.state.inputValue);
                autoClose && this.close();
            } }, positiveButtonText), React.createElement(react_bootstrap_1.Button, { type: "button", bsStyle: "default", onClick: () => {
                if (!util_1.isNullOrUndefined(options.onNegative)) {
                    options.onNegative();
                }
                autoClose && this.close();
            } }, negativeButtonText)));
    }
    alertDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, { dangerouslySetInnerHTML: { __html: options.message } }), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { "data-cy": "topAlertDialogClose", bsStyle: "default", onClick: () => {
                autoClose && this.close();
            } }, options.buttonText || "Close")));
    }
    selectDialog() {
        const options = this.props.payload;
        if (options.selectType === DialogActions_1.SelectDialogType.Select) {
            return this.simpleSelectDialog();
        } else if (options.selectType === DialogActions_1.SelectDialogType.Select2) {
            return this.select2Dialog();
        }
    }
    simpleSelectDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Ok";
        const data = options.data;
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement(react_bootstrap_1.FormGroup, { controlId: "selectDialogInput" }, React.createElement(react_bootstrap_1.ControlLabel, { dangerouslySetInnerHTML: { __html: options.message } }), React.createElement(react_bootstrap_1.FormControl, { componentClass: "select", placeholder: "select", value: options.value, onChange: event => this.setState({ inputValue: event.target.value }) }, this.createOptions(data)), React.createElement(react_bootstrap_1.FormControl.Feedback, null))), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: () => {
                options.onPositive(this.state.inputValue);
                autoClose && this.close();
            } }, positiveButtonText), React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                autoClose && this.close();
            } }, "Cancel")));
    }
    select2Dialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Ok";
        const hideNegativeButton = util_1.isNullOrUndefined(options.hideNegativeButton) ? false : options.hideNegativeButton;
        const data = options.data;
        const modal = options.modal || { keyboard: true, backdrop: true };
        const select2 = options.select2 || { matchProp: "label", clearable: true };
        let select;
        if (data instanceof Array) {
            let dataArray = [];
            for (let i = 0; i < data.length; i++) {
                dataArray.push({ label: data[i], value: data[i] });
            }
            select = React.createElement(Select, { name: "form-dialog-select2-name", value: this.state.inputValue, options: dataArray, matchProp: select2.matchProp, clearable: select2.clearable, onChange: selectedItem => this.setState({ inputValue: selectedItem.value }) });
        } else {
            select = React.createElement(Select, { name: "form-dialog-select2-name", value: this.state.inputValue, options: data.items, valueKey: data.valueKey, labelKey: data.labelKey, clearable: select2.clearable, matchProp: select2.matchProp, onChange: selectedItem => this.setState({ inputValue: selectedItem }) });
        }
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => hideNegativeButton && this.close(), onExited: this.onExited, keyboard: modal.keyboard, backdrop: modal.backdrop }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement(react_bootstrap_1.FormGroup, { controlId: "select2DialogInput" }, React.createElement(react_bootstrap_1.ControlLabel, { dangerouslySetInnerHTML: { __html: options.message } }), select)), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: () => {
                options.onPositive(this.state.inputValue);
                autoClose && this.close();
            } }, positiveButtonText), !hideNegativeButton && React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                autoClose && this.close();
            } }, "Cancel")));
    }
    blockedNumbersDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Yes";
        const negativeButtonText = options.negativeButtonText || "No";
        const numbers = options.phoneNumbers.map(({ phone, name }, index) => {
            if (this.state.checkedNumbersForUnblock.indexOf(phone) === -1) {
                return React.createElement("p", { key: index, className: options.phoneNumbers.length > 4 ? "col-xs-6" : "col-xs-12" }, React.createElement("span", { className: "pointer", onClick: () => this.checkPhoneNumbersForUnblock(true, phone) }, React.createElement("i", { className: "fa fa-square-o" }, " "), " ", phone, " "));
            } else {
                return React.createElement("p", { key: index, className: options.phoneNumbers.length > 4 ? "col-xs-6" : "col-xs-12" }, React.createElement("span", { className: "pointer", onClick: () => this.checkPhoneNumbersForUnblock(false, phone) }, React.createElement("i", { className: "fa fa-check-square-o" }, " "), " ", phone, " "));
            }
        });
        return React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title)), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement("p", { dangerouslySetInnerHTML: { __html: options.message } }), React.createElement("div", { className: "row" }, numbers)), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", disabled: this.state.checkedNumbersForUnblock.length === 0, onClick: () => {
                options.onUnlock(this.state.checkedNumbersForUnblock);
                autoClose && this.close();
            } }, positiveButtonText), React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                if (!util_1.isNullOrUndefined(options.onNegative)) {
                    options.onNegative();
                }
                autoClose && this.close();
            } }, negativeButtonText)));
    }
    BlackWordDialog() {
        const options = this.props.payload;
        const autoClose = util_1.isNullOrUndefined(options.autoClose) ? true : options.autoClose;
        const positiveButtonText = options.positiveButtonText || "Yes";
        return React.createElement(react_bootstrap_1.Modal, { className: "word-modal", show: this.state.show, onHide: () => {}, onExited: this.onExited }, React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement(react_bootstrap_1.Modal.Title, null, options.title, " Block Word")), React.createElement(react_bootstrap_1.Modal.Body, null, React.createElement("div", { className: util_1.isNullOrUndefined(this.state.blackWordErrors.replaceTo) ? "form-group" : "form-group has-danger" }, React.createElement("label", { className: util_1.isNullOrUndefined(this.state.blackWordErrors.badWord) ? "" : "text-danger" }, "Bad Word"), React.createElement("input", { type: "text", className: "form-control", ref: "badWord", defaultValue: util_1.isNullOrUndefined(options.badWord) ? "" : options.badWord }), React.createElement("small", { className: "text-danger" }, this.state.blackWordErrors.badWord)), React.createElement("div", { className: util_1.isNullOrUndefined(this.state.blackWordErrors.replaceTo) ? "form-group" : "form-group has-danger" }, React.createElement("label", { className: util_1.isNullOrUndefined(this.state.blackWordErrors.replaceTo) ? "" : "text-danger" }, "Replace To"), React.createElement("input", { type: "text", className: "form-control", ref: "replaceTo", defaultValue: util_1.isNullOrUndefined(options.replaceTo) ? "" : options.replaceTo }), React.createElement("small", { className: "text-danger" }, this.state.blackWordErrors.replaceTo))), React.createElement(react_bootstrap_1.Modal.Footer, null, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", onClick: () => {
                if (this.isValidBlackWord()) {
                    options.onPositive($(this.refs.badWord).val().toString(), $(this.refs.replaceTo).val().toString());
                    autoClose && this.close();
                }
            } }, positiveButtonText), React.createElement(react_bootstrap_1.Button, { bsStyle: "default", onClick: () => {
                if (!util_1.isNullOrUndefined(options.onNegative)) {
                    options.onNegative();
                }
                autoClose && this.close();
            } }, "Cancel")));
    }
    isValidBlackWord() {
        const blackWordErrors = { badWord: null, replaceTo: null };
        let valid = true;
        if (util_1.isNullOrUndefined($(this.refs.badWord).val().toString()) || $(this.refs.badWord).val().toString().trim() === "") {
            blackWordErrors.badWord = "This field can't be blank.";
            valid = false;
        }
        if (util_1.isNullOrUndefined($(this.refs.replaceTo).val().toString()) || $(this.refs.replaceTo).val().toString().trim() === "") {
            blackWordErrors.replaceTo = "This field can't be blank.";
            valid = false;
        }
        this.setState({ blackWordErrors });
        return valid;
    }
    checkPhoneNumbersForUnblock(check, phone) {
        if (check) {
            this.setState(prevState => ({
                checkedNumbersForUnblock: [...prevState.checkedNumbersForUnblock, phone]
            }));
        } else {
            const checkedNumbersForUnblock = this.state.checkedNumbersForUnblock;
            const index = checkedNumbersForUnblock.indexOf(phone);
            checkedNumbersForUnblock.splice(index, 1);
            this.setState({ checkedNumbersForUnblock });
        }
    }
    createOptions(items) {
        let options = [];
        if (items instanceof Array) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                options.push(React.createElement("option", { key: "dialog_select_option_" + i, value: i }, item));
            }
        }
        return options;
    }
}
exports.default = react_redux_1.connect(mapStateToProps)(DialogComponent);


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Dialog/components/DialogComponent.tsx
// module id = 1110
// module chunks = 0 1 2